"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DisablingMask = exports.EditModeWrapper = exports.FormInputsGeneratorTitle = exports.InputInner = exports.InputWrapper = exports.Footer = exports.Center = exports.FormPreview = exports.FormInputsGeneratorHeader = exports.FormInputsGeneratorInner = exports.FormInputsGenerator = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var baseZindex = 1,
    FormInputsGenerator = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormInputsGenerator"
})(["border:2px dotted #d9d9d9;margin-bottom:1rem;position:relative;", " ", ";"], function (a) {
  return a.overlay && "z-index: ".concat(2);
}, function (a) {
  return a.overlay && "\n    &:before{\n      content:\"\";\n      background-color: rgba(0,0,0,.3);\n      position: absolute;\n      top: -100vh;\n      bottom: -100vh;\n      right: -100vw;\n      left: -100vw;\n      z-index: -1;\n    }\n  ";
});

exports.FormInputsGenerator = FormInputsGenerator;

var FormInputsGeneratorInner = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormInputsGeneratorInner"
})(["background:white;top:0;bottom:0;right:0;left:0;padding:1rem;"]);

exports.FormInputsGeneratorInner = FormInputsGeneratorInner;

var FormInputsGeneratorHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormInputsGeneratorHeader"
})(["display:flex;justify-content:space-between;"]);

exports.FormInputsGeneratorHeader = FormInputsGeneratorHeader;

var FormPreview = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormPreview"
})(["position:relative;"]);

exports.FormPreview = FormPreview;

var Center = _styledComponents["default"].div.withConfig({
  displayName: "styles__Center"
})(["text-align:center;margin-top:1rem;"]);

exports.Center = Center;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "styles__Footer"
})(["text-align:right;"]);

exports.Footer = Footer;

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputWrapper"
})(["position:relative;transition:0.15s all;padding:0.5rem;&:before{content:'';position:absolute;left:0;bottom:0;top:0;bottom:0;width:0.2rem;background-color:#ffd500;opacity:0;transition:0.15s opacity;}&:hover:before{opacity:1;}&:hover{background:", ";.inputInner{opacity:1;}}"], function (a) {
  return a.theme.colors.blue.light;
});

exports.InputWrapper = InputWrapper;

var InputInner = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputInner"
})(["position:absolute;z-index:", ";right:0;top:0;padding:0.5rem;display:flex;background:", ";opacity:0;transition:0.15s all;align-items:center;button{margin-right:1rem;}& >:last-child{button{margin-right:0;}}"], 1, function (a) {
  return a.theme.colors.blue.light;
});

exports.InputInner = InputInner;

var FormInputsGeneratorTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormInputsGeneratorTitle"
})(["font-size:1.5rem;margin-bottom:0.5rem;margin-bottom:0.5rem;width:10;color:", ";font-weight:300;"], function (a) {
  return a.theme && a.theme.colors && a.theme.colors.blue && a.theme.colors.blue.main;
});

exports.FormInputsGeneratorTitle = FormInputsGeneratorTitle;

var EditModeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__EditModeWrapper"
})(["position:relative;"]);

exports.EditModeWrapper = EditModeWrapper;

var DisablingMask = _styledComponents["default"].div.withConfig({
  displayName: "styles__DisablingMask"
})(["position:absolute;top:0;left:0;right:0;bottom:0;cursor:not-allowed;z-index:1;"]);

exports.DisablingMask = DisablingMask;